module.exports = __webpack_public_path__ + "img/empty.47212a2b.png";